<template>

</template>
<script>
export default {
  name: 'section-footer',
  props: {
    bottomMenu: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {}
  }
}
</script>